import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pt_stow",
  "use": "icon-pt_stow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pt_stow\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M18.87,12A1,1,0,0,1,18,13H11.74a1,1,0,0,1,0-2H18A1,1,0,0,1,18.87,12Zm-13-6H18.12A.94.94,0,0,1,19,7a.94.94,0,0,1-.88,1H5.88A.94.94,0,0,1,5,7,.94.94,0,0,1,5.88,6Zm0,10H18.12a1,1,0,0,1,0,2H5.88a1,1,0,0,1,0-2ZM9,13.93V10a.54.54,0,0,0-.52-.55.5.5,0,0,0-.27.08l-3,1.95a.57.57,0,0,0-.17.76.42.42,0,0,0,.17.18l3,2a.5.5,0,0,0,.71-.18A.6.6,0,0,0,9,13.93Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol